var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "emd-flex-grow_1 emd-flex-shrink_1 emd-flex emd-overflow_hidden",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "emd-container__content emd-flex emd-justify_space-between emd-overflow_hidden",
        },
        [
          _c("emd-alert", { attrs: { variant: "success", autoclose: false } }, [
            _c("div", { attrs: { slot: "content" }, slot: "content" }, [
              _vm.action === "setAsEmployee"
                ? _c("p", [
                    _vm._v(
                      " " + _vm._s(_vm.$t("success.titleSetAsEmployee")) + " "
                    ),
                  ])
                : _c("p", [_vm._v(_vm._s(_vm.$t("success.titleInvite")))]),
            ]),
          ]),
          _c("div", { staticClass: "eu-mt_5" }, [
            _c("div", { staticClass: "el-chunk" }, [
              _c(
                "p",
                { staticClass: "emd-text _type_caption _color_contrast" },
                [_vm._v(" " + _vm._s(_vm.$t("success.informations")) + " ")]
              ),
            ]),
            _c("div", { staticClass: "el-chunk" }, [
              _c(
                "h4",
                {
                  staticClass: "emd-text _type_caption _color_contrast eu-mb_1",
                },
                [_vm._v(" " + _vm._s(_vm.$t("success.name")) + " ")]
              ),
              _c("p", { staticClass: "emd-text _color_subtle" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.user.first_name) +
                    " " +
                    _vm._s(_vm.user.last_name) +
                    " "
                ),
              ]),
            ]),
            _c("div", { staticClass: "el-chunk" }, [
              _c(
                "h4",
                {
                  staticClass: "emd-text _type_caption _color_contrast eu-mb_1",
                },
                [_vm._v(" " + _vm._s(_vm.$t("success.email")) + " ")]
              ),
              _c("p", { staticClass: "emd-text _color_subtle" }, [
                _vm._v(_vm._s(_vm.user.email)),
              ]),
            ]),
            _c("div", { staticClass: "el-chunk" }, [
              _c(
                "h4",
                {
                  staticClass: "emd-text _type_caption _color_contrast eu-mb_2",
                },
                [_vm._v(" " + _vm._s(_vm.$t("success.permission")) + ": ")]
              ),
              _c("span", { staticClass: "emd-badge" }, [
                _vm._v(_vm._s(_vm.permission)),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "emd-container__footer emd-ta_right" }, [
        _c(
          "button",
          {
            staticClass: "emd-btn _color_primary",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.$emit("done")
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("done")) + " ")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }